
export const getShortPushNotification = (message) => {
    let trimContent = message;
    if (message?.length > 250) {
        trimContent = message;
    }
    return trimContent;
}